
import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import StockAdjustmentModule from "@/store/modules/barcodeSystem/stockAdjustment";
import notifications from "@/lib/notifications";
import { StockAdjustmentListFilters } from "@/models/api/barcodeSystem/stockAdjustments/get";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const stockAdjustmentModuleState = getModule(StockAdjustmentModule);
const barcodeSystemModuleState = getModule(BarcodeSystemModule);

@Component
export default class StockAdjustmentFilters extends Vue {
  localFilters: StockAdjustmentListFilters = null;

  get filters() {
    return stockAdjustmentModuleState.filters;
  }

  created() {
    this.localFilters = JSON.parse(JSON.stringify(this.filters));
  }

  async submit() {
    stockAdjustmentModuleState.setFilters(JSON.parse(JSON.stringify(this.localFilters)));
    stockAdjustmentModuleState.setLoading(true);
    try {
      await stockAdjustmentModuleState.getStockAdjustments({
        pageNumber: 1,
        pageSize: stockAdjustmentModuleState.pageData.pageSize
      });
    } catch (ex) {
      notifications.error("Loading Stock Adjustments", "Failed to load stock adjustments", ex);
    }

    stockAdjustmentModuleState.setLoading(false);
  }

  get currentFacilityCode(): string {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  get loading(): boolean {
    return stockAdjustmentModuleState.loading;
  }

  getBooleanOptions() {
    return [
      { label: "", value: null },
      { label: "Yes", value: true },
      { label: "No", value: false }
    ];
  }
}
